export default __webpack_public_path__ + "static/media/button-action.16913a19.svg";